// extracted by mini-css-extract-plugin
export default {"popup":"ModalPuzzle_popup__UQ2Rv","popupContent":"ModalPuzzle_popupContent__HTydW","popupText":"ModalPuzzle_popupText__DoaiF"};